import React, { useState } from "react";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { Col, DatePicker, Form, Input, Row } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import Inputs from "../../../../biblio/Inputs/Inputs";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../../components/utils/utils";
import {
  AddDroppedOutRequest,
  getDroppedOutRequests,
} from "../../../../apis/actions/scholarship.actions";
import Selects from "../../../../biblio/Selects/Selects";
import dayjs from "dayjs";
import { setResModel ,setResIds } from "../../../../apis/slices/ratingSlice";
interface Props {
  beneficiary: any;
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}
const { TextArea } = Input;
const DropoutRequest = ({
  beneficiary,
  isModalVisible,
  setIsModalVisible,
}: Props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [state, setState] = useState("");
  const handleFileChange = async (fileList: any[]) => {
    const attachments = [];
    for (const fileItem of fileList) {
      const file = fileItem?.originFileObj;
      if (file) {
        try {
          const base64 = await convertFileToBase64(file);
          const imageData = {
            filename: file.name,
            data: base64,
          };
          attachments.push(imageData);
          form.setFieldsValue({
            last_degree_attachment_ids: attachments,
          });
        } catch (error) {
          console.error("Error converting file to Base64:", error);
        }
      }
    }
  };
  const onFinish = async () => {
    try {
      await form.validateFields();

      const FormValues = form.getFieldsValue();
      const requestFormData = {
        partner_id: form.getFieldValue("partner_id").value,
        last_degree_year: state,
        accumulated_rate: FormValues.accumulated_rate,
        reason: FormValues.reason,
        last_degree_attachment_ids: FormValues.last_degree_attachment_ids ?? [],
      };
      dispatch(AddDroppedOutRequest(requestFormData)).then((result: any) => {
        const dropoutRequest = result?.payload?.result;
        if (dropoutRequest?.code === 200) {
          dispatch(setResModel(dropoutRequest?.res_model));
          dispatch(setResIds([dropoutRequest?.dropout_id]));
          showNotitfication(dropoutRequest?.message, "success", dispatch);
          dispatch(getDroppedOutRequests({ limit : 8 , page :1}));
          setIsModalVisible(false);
          form.resetFields();
        } else {
          showNotitfication(dropoutRequest?.message, "error");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      centered={true}
      modalStyle={{ top: -200 }}
    >
      <Form form={form} layout="vertical">
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">طلب المنقطعين عن الدراسة</p>
        </Row>
        <Row
          gutter={16}
          style={{ paddingTop: "2rem" }}
          className={`takaful--content-profile-box1 takaful--content-select`}
        >
          <Col
            xxl={8}
            xl={8}
            lg={8}
            md={8}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="partner_id"
              label="المستفيد"
              labelAlign="left"
              labelCol={{
                className: "takaful--label-style",
              }}
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <Selects
                options={beneficiary}
                className="takaful--request-select"
              />
            </Form.Item>
          </Col>
          <Col
            xxl={8}
            xl={8}
            lg={8}
            md={8}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="last_degree_year"
              label="اخر سنة دراسة تحصل فيها على شهادة"
              labelCol={{
                className: "takaful--label-style",
              }}
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <DatePicker
                className="takaful--input takaful--input-date"
                placeholder="السنة"
                picker="year"
                size="large"
                onChange={(e, date) => {
                  setState(e ? date.toString() : "");
                }}
                allowClear
                disabledDate={(current) => {
                  return current && current > dayjs().endOf("year");
                }}
              />
            </Form.Item>
          </Col>
          <Col
            xxl={8}
            xl={8}
            lg={8}
            md={8}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="accumulated_rate"
              label="المعدل التراكمي"
              labelCol={{
                className: "takaful--label-style",
              }}
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <Inputs type="tel" />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={16}
          className={`takaful--content-profile-box1 takaful--content-select`}
        >
          <Col
            xxl={16}
            xl={16}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="reason"
              label="السبب"
              labelCol={{
                className: "takaful--label-style",
              }}
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Col>
          <Col
            xxl={8}
            xl={8}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            className="takaful--content-profile-col"
          >
            <Form.Item
              name="last_degree_attachment_ids"
              label="مرفقات"
              className="takaful--label-inputs"
              labelCol={{
                className: "takaful--label-style",
              }}
              rules={[
                {
                  required: false,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
            >
              <UploadInput
                text="إرفاق أي مستندات تدعم الطلب"
                icon={<UploadOutlined />}
                multiple={true}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إرسال"
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default DropoutRequest;
